module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Protected-file-e3f88d57f8a752f7db5b612ca763a75c.svg";